import { render, staticRenderFns } from "./NewMatrixKind.vue?vue&type=template&id=028ccbd0&"
import script from "./NewMatrixKind.vue?vue&type=script&lang=js&"
export * from "./NewMatrixKind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports